export const SET_CAT_INTRO = 'cat-intro/SET_CAT_INTRO';
export const SET_CAT_INTRO_ERROR = 'cat-intro/SET_CAT_INTRO_ERROR';
